import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function CategoryGrid() {
  const mainCategories = comicCategories.filter(c => c.slug !== 'all');

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            分类浏览
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          <Link
            to="/category/all"
            className="group relative bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg p-4 md:p-5 flex flex-col items-center justify-center text-white min-h-[100px] hover:from-primary-600 hover:to-primary-700 transition-all duration-300"
          >
            <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-white/20 rounded-full mb-2">
              <i className="ri-apps-line text-xl md:text-2xl"></i>
            </div>
            <span className="text-sm md:text-base font-bold whitespace-nowrap">全部漫画</span>
          </Link>

          {mainCategories.slice(0, 8).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-4 md:p-5 flex flex-col items-center justify-center min-h-[100px] hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-300"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-secondary-100 rounded-full mb-2 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-secondary-600 group-hover:text-primary-500 transition-colors`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">{cat.name}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}